import React from "react";
import _ from "lodash";
import moment from "moment-timezone";
import { DateRange } from "react-date-range";
import PopupWrapper from "./PopupWrapper";
import { IoIosArrowDown } from "react-icons/io";
import {
  DATE_RANGES,
  getDateRangeByType,
} from "components/playground/home-dashboard-v2/DateHelper";

class DateRangePicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.child = React.createRef();

    this.handleCancel = this.handleCancel.bind(this);
    this.handleApply = this.handleApply.bind(this);
  }

  handleCancel() {
    this.child.current.handleClosePopup();
  }

  handleApply({ startDate, endDate }) {
    this.props.handleDateRangeChanged({ startDate, endDate });
  }

  render() {
    const {
      startDate,
      endDate,
      format = "YYYY-MM-DD",
      minDate = moment().subtract(5, "year").toDate(),
      months = 2,
      dateRanges = DATE_RANGES,
      place = "bottom left",
    } = this.props;

    const startDateFormatted = moment(startDate).format(format);
    const endDateFormatted = moment(endDate).format(format);

    return (
      <PopupWrapper
        ref={this.child}
        place={place}
        triggerType="click"
        hideArrow={false}
        triggerElement={
          <div className="border rounded hover:shadow focus:outline-none inline-flex cursor-pointer items-center border-gray-400 bg-white px-4 py-2 text-sm text-gray-700">
            <span className="mr-4">
              <span className="text-sm text-gray-600">
                From <b className="text-gray-700">{startDateFormatted}</b> to{" "}
                <b className="text-gray-700">{endDateFormatted}</b>
              </span>
            </span>

            <IoIosArrowDown></IoIosArrowDown>
          </div>
        }
        popupElement={
          <DateRangePopover
            startDate={startDate}
            endDate={endDate}
            dateRanges={dateRanges}
            months={months}
            minDate={minDate}
            handleCancel={this.handleCancel}
            handleApply={this.handleApply}
          ></DateRangePopover>
        }
      ></PopupWrapper>
    );
  }
}

class DateRangePopover extends React.PureComponent {
  constructor(props) {
    super(props);

    const { startDate, endDate } = this.props;

    this.state = {
      startDate,
      endDate,
    };

    this.onDateRangeChange = this.onDateRangeChange.bind(this);
    this.handleSelectDateRange = this.handleSelectDateRange.bind(this);
    this.handleApply = this.handleApply.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  onDateRangeChange(ranges) {
    const { startDate, endDate } = ranges.dateRange;

    this.setState({
      startDate,
      endDate,
    });
  }

  handleSelectDateRange(dateRangeType) {
    const { startDate, endDate } = getDateRangeByType(dateRangeType);

    this.setState({
      startDate,
      endDate,
    });
  }

  handleApply() {
    const { startDate, endDate } = this.state;
    const { handleApply, handleCancel } = this.props;
    if (handleApply) handleApply({ startDate, endDate });
    if (handleCancel) handleCancel();
  }

  handleCancel() {
    if (this.props.handleCancel) {
      this.props.handleCancel();
    }
  }

  render() {
    const { startDate, endDate } = this.state;
    const { hidePresets, minDate, months, dateRanges } = this.props;

    return (
      <>
        <div className="p-4 shadow-2xl">
          <div className="flex">
            {!hidePresets && (
              <div>
                {dateRanges.map((dateRangeType) => {
                  const dateRangeTitle = _.capitalize(
                    _.lowerCase(dateRangeType)
                  );
                  return (
                    <div key={dateRangeType}>
                      <button
                        type="button"
                        onClick={() =>
                          this.handleSelectDateRange(dateRangeType)
                        }
                        className="border rounded mb-2 mr-3 inline-flex cursor-pointer bg-white px-3 py-1 text-sm text-gray-700 hover:border-blue-400"
                      >
                        {dateRangeTitle}
                      </button>
                    </div>
                  );
                })}
              </div>
            )}

            <div>
              <DateRange
                editableDateInputs={true}
                onChange={this.onDateRangeChange}
                moveRangeOnFirstSelection={false}
                months={months}
                dateDisplayFormat={"yyyy/MM/dd"}
                direction="horizontal"
                scroll={{ enabled: true }}
                maxDate={moment().toDate()}
                minDate={minDate}
                ranges={[
                  {
                    startDate: moment(startDate).toDate(),
                    endDate: moment(endDate).toDate(),
                    key: "dateRange",
                  },
                ]}
              />
            </div>
          </div>

          <div className="border-t flex justify-end pt-4">
            <button
              type="button"
              className="px-6 text-blue-500 hover:text-blue-600"
              onClick={this.handleCancel}
            >
              Cancel
            </button>

            <button
              type="button"
              className="rounded inline-flex justify-center bg-blue-500 px-10 py-2 text-sm text-white shadow-sm hover:bg-blue-600"
              onClick={this.handleApply}
            >
              Apply
            </button>
          </div>
        </div>
      </>
    );
  }
}

export default DateRangePicker;
